import React from 'react';
import './TeamCard.css'

const TeamCard = (props) => {
    return ( 
        <div className='TeamCard'>
            <img className='TeamImg' src={props.TeamImg} alt="" />

            <div className='TCardContent'>
                <p className='TeamName'>{props.TeamName}</p>
                <p className='TeamPos'>{props.TeamPos}</p>
                <p className='TeamSub'>{props.TeamSub}</p>
            </div>
        </div>
     );
}
 
export default TeamCard;